"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumCompanyProfileSubscriptionCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@ant-design/icons");
const elements_1 = require("@src/components/elements");
const get_product_pricing_1 = require("@src/shared/get-product-pricing");
const types_1 = require("@src/types");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importStar(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const styled_breakpoints_1 = require("styled-breakpoints");
const polished_1 = require("polished");
const PremiumCompanyProfileSubscriptionCard = ({ subscriptionPeriod, showPricesWithVat, isElevated }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const { totalPriceWithoutVat, discountRelative, productPriceWithoutVat, productPrice, totalPrice } = (0, get_product_pricing_1.getProductPricing)({
        productId: types_1.ProductId.companyPremium,
        productCount: subscriptionPeriod,
    });
    const costPerMonth = showPricesWithVat ? productPrice : productPriceWithoutVat;
    const total = showPricesWithVat ? totalPrice : totalPriceWithoutVat;
    return ((0, jsx_runtime_1.jsxs)(BoxWhite, { subscriptionPeriod: subscriptionPeriod, isElevated: isElevated, children: [(0, jsx_runtime_1.jsxs)(ContentWrapper, { children: [(0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SubscriptionPeriodTitle, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.month.pluralized", values: { count: subscriptionPeriod } }) }), subscriptionPeriod === types_1.SubscriptionPeriods.TwelveMonthsPeriod && ((0, jsx_runtime_1.jsx)(BestPriceTag, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-row align-center", children: [(0, jsx_runtime_1.jsx)(icons_1.StarFilled, { className: "m-r-s" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.best_price" })] }) }))] }), (0, jsx_runtime_1.jsxs)(PricePerMonthSection, { children: [(0, jsx_runtime_1.jsx)(StyledPricePerMonth, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: costPerMonth, style: "currency", currency: "EUR" }) }), (0, jsx_runtime_1.jsx)(PerMonthFontWrapper, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.subscription.per_month" }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "flex-center", children: (0, jsx_runtime_1.jsx)(StyledDiv, {}) })] }), (0, jsx_runtime_1.jsxs)(CardFooter, { children: [discountRelative > 0 && ((0, jsx_runtime_1.jsxs)(DiscountWrapper, { children: [(0, jsx_runtime_1.jsx)(GrayText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.subscription.your_discount" }) }), (0, jsx_runtime_1.jsxs)(Discount, { children: ["~", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: discountRelative, style: "unit", unit: "percent" })] })] })), (0, jsx_runtime_1.jsxs)("div", { className: "text-center font-bold font-size-m", children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.subscription.total" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: total, style: "currency", currency: "EUR" })] }), (0, jsx_runtime_1.jsx)("div", { className: "flex-col align-center justify-center", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "primary", shape: "round", onClick: () => history.pushLocalized(`/admin/objednavka?product=${types_1.ProductId.companyPremium}&amount=${subscriptionPeriod}`), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.buy_subscription" }) }) })] })] }));
};
exports.PremiumCompanyProfileSubscriptionCard = PremiumCompanyProfileSubscriptionCard;
const BoxWhite = styled_components_1.default.div `
	padding: 3rem 2rem 1rem;
	width: 100%;
	min-height: 350px;
	position: relative;
	background: ${({ theme }) => theme.color.white};
	border-radius: 1rem;
	overflow: hidden;
	box-shadow: 0 15px 35px rgb(50 50 77 / 10%), 0 5px 15px rgb(0 0 0 / 7%);
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	color: ${({ theme }) => theme.color.white};
	${({ subscriptionPeriod, theme }) => {
    if (subscriptionPeriod === types_1.SubscriptionPeriods.OneMonthPeriod) {
        return (0, styled_components_1.css) `
				background: linear-gradient(150deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, 0.3) 90%),
					${(0, polished_1.darken)(0.1, theme.color.brand2)};
			`;
    }
    if (subscriptionPeriod === types_1.SubscriptionPeriods.SixMonthsPeriod) {
        return (0, styled_components_1.css) `
				background: linear-gradient(150deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, 0.3) 90%),
					${(0, polished_1.darken)(0.1, theme.color.brand1)};
			`;
    }
    if (subscriptionPeriod === types_1.SubscriptionPeriods.TwelveMonthsPeriod) {
        return (0, styled_components_1.css) `
				background: linear-gradient(150deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, 0.3) 90%),
					${theme.color.brandDarkBlue};
			`;
    }
}};
`;
const GrayText = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray4};
`;
const SubscriptionPeriodTitle = styled_components_1.default.div `
	font-size: 1.25rem;
	font-weight: bold;
	display: flex;
	${(0, styled_breakpoints_1.up)('xs')} {
		justify-content: center;
	}
	${(0, styled_breakpoints_1.only)('xs')} {
		width: 100%;
	}
	${(0, styled_breakpoints_1.up)('md')} {
		justify-content: flex-start;
	}
`;
const ContentWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
const StyledPricePerMonth = styled_components_1.default.div `
	font-size: 3rem;
	font-weight: bold;
	margin-right: 0.5rem;
	${(0, styled_breakpoints_1.up)('xs')} {
		display: flex;
		justify-content: center;
	}
	${(0, styled_breakpoints_1.only)('xs')} {
		width: 100%;
	}
	${(0, styled_breakpoints_1.up)('md')} {
		font-size: 2.5rem;
	}
	${(0, styled_breakpoints_1.up)('xl')} {
		font-size: 3rem;
	}
`;
const PricePerMonthSection = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: baseline;
	font-size: 1.5rem;

	${(0, styled_breakpoints_1.up)('xs')} {
		justify-content: center;
	}
	${(0, styled_breakpoints_1.up)('sm')} {
		flex-direction: row;
	}
	${(0, styled_breakpoints_1.up)('md')} {
		justify-content: flex-start;
		flex-direction: column;
	}
	${(0, styled_breakpoints_1.up)('lg')} {
		flex-direction: row;
	}
`;
const Discount = styled_components_1.default.span `
	margin-left: 0.5rem;
	font-size: 1.75rem;
	font-weight: bold;
	color: ${({ theme }) => theme.color.success};
	background: ${({ theme }) => theme.color.white};
	border-radius: 0.5rem;
	padding: 0 0.5rem;
`;
const CardFooter = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	gap: 0.5rem;
`;
const CardTag = (0, styled_components_1.default)(elements_1.Tag) `
	color: ${({ theme }) => theme.color.gray4};
	font-size: 0.9rem;
	padding: 0.5rem 1rem;
	top: 0;
	position: absolute;
	border: 0;
	border-radius: 0 0 0.5rem 0.5rem;
	left: 50%;
	transform: translate(-50%, 0);
`;
const BestPriceTag = (0, styled_components_1.default)(CardTag) `
	background: ${({ theme }) => theme.color.success};
	color: ${({ theme }) => theme.color.white};
`;
const StyledDiv = styled_components_1.default.div `
	width: 100%;
	height: 0.125rem;
	background: rgba(255, 255, 255, 0.6);
`;
const DiscountWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 1rem;
	${(0, styled_breakpoints_1.up)('md')} {
		margin: 0;
	}
`;
const PerMonthFontWrapper = styled_components_1.default.div `
	font-size: 1.25rem;
	color: ${({ theme }) => theme.color.gray4};
	${(0, styled_breakpoints_1.up)('xs')} {
		display: flex;
		justify-content: center;
	}
	${(0, styled_breakpoints_1.up)('md')} {
		font-size: 1rem;
	}
	${(0, styled_breakpoints_1.only)('xs')} {
		width: 100%;
	}
	${(0, styled_breakpoints_1.up)('xl')} {
		font-size: 1.5rem;
	}
`;
